
import Swiper, { Navigation, Thumbs } from "swiper";

let swiper = new Swiper(".mySwiper", {
    spaceBetween: 24,
    slidesPerView: 4,
    touchRatio: 0.2,
    loop: false,
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 2,
            spaceBetween: 10
        },
        // when window width is >= 480px
        480: {
            slidesPerView: 3,
            spaceBetween: 20
        },
        // when window width is >= 640px
        640: {
            slidesPerView: 4,
            spaceBetween: 24
        }
    }
});
new Swiper(".mySwiper2", {
    modules: [Navigation, Thumbs],
    spaceBetween: 24,
    autoScrollOffset: 1,
    thumbsContainerClass: 'swiper-block',
    navigation: {
        nextEl: ".swiper-button-next-gallery",
        prevEl: ".swiper-button-prev-gallery",
    },
    thumbs: {
        swiper: swiper,
    },
});